// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-component.loading-notice .loading:after{content:\".\";animation:dots 1.25s steps(5) infinite;font-size:1.5em;line-height:1em;font-weight:700}@keyframes dots{0%,20%{color:transparent;text-shadow:.25em 0 0 transparent,.5em 0 0 transparent}40%{color:#000;text-shadow:.25em 0 0 transparent,.5em 0 0 transparent}60%{text-shadow:.25em 0 0 #000,.5em 0 0 transparent}80%,to{text-shadow:.25em 0 0 #000,.5em 0 0 #000}}", ""]);
// Exports
module.exports = exports;
